import {
  CustomerConfigTranslatedStringKeyPaths,
  TranslationTypes,
} from '@/translations/constants';
import { useTranslation } from '@/translations/hooks';

export function useTransientOccupancyTaxName({
  translationType = TranslationTypes.DEFAULT,
} = {}) {
  return useTranslation({
    translatedStringKeyPath: CustomerConfigTranslatedStringKeyPaths.TOT,
    translationType,
  });
}
